export default "__VITE_ASSET__DXVt65VG__"